export default __webpack_public_path__ + "static/media/log.7557e31d.svg";